import Vue from 'vue';
import Router from 'vue-router';
import Index from '@/components/Index';
import Gallery from '@/components/pages/Gallery';
import Timetables from '@/components/pages/Timetable';
import ClubPage from '@/components/pages/ClubPage';
import TrainingsPage from '@/components/pages/Training';
import CoachPage from '@/components/pages/CoachPage';
import AthletePage from '@/components/pages/AthletePage';
import InstructorPage from '@/components/pages/InstructorPage';
import DirectoratePage from '@/components/pages/DirectoratePage';
import CompetitionsPage from '@/components/pages/CompetitionsPage';
import NotFoundPage from '@/components/pages/NotFound';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'index',
            component: Index,
        },
        {
            path: '/404',
            name: 'NotFound',
            component: NotFoundPage,
        },
        {
            path: '/gal',
            name: 'gal',
            component: Gallery,
        },
        {
            path: '/club',
            name: 'club',
            component: ClubPage,
        },
        {
            path: '/club/training/:page',
            name: 'training',
            component: TrainingsPage
        },
        {
            path: '/club/athlete',
            name: 'Athlete',
            component: AthletePage
        },
        {
            path: '/club/coach',
            name: 'Coach',
            component: CoachPage
        },
        {
            path: '/club/instructor',
            name: 'Instructor',
            component: InstructorPage
        },
        {
            path: '/club/directorate',
            name: 'Directorate',
            component: DirectoratePage
        },
        {
            path: '/club/competitions',
            name: 'Competitions',
            component: CompetitionsPage
        },
        {
            path: '/article/:id',
            name: 'article',
            component: Index,
        },
        {
            path: '/schedule',
            name: 'timetables',
            component: Timetables,
        },
        { path: '*', redirect: '/404' }
    ],
    mode: 'history',
});
